export var STATUS_TO_CONNOTATION_MAP = /*#__PURE__*/ function(STATUS_TO_CONNOTATION_MAP) {
    STATUS_TO_CONNOTATION_MAP["approved"] = "info";
    STATUS_TO_CONNOTATION_MAP["declined"] = "alert";
    STATUS_TO_CONNOTATION_MAP["in_manual_review"] = "primary";
    STATUS_TO_CONNOTATION_MAP["live"] = "primary";
    STATUS_TO_CONNOTATION_MAP["submitted"] = "primary";
    STATUS_TO_CONNOTATION_MAP["waiting_for_submission"] = "cta";
    STATUS_TO_CONNOTATION_MAP["waiting_manual_review"] = "cta";
    return STATUS_TO_CONNOTATION_MAP;
}({});
export var STATUS_TO_ICON_MAP = /*#__PURE__*/ function(STATUS_TO_ICON_MAP) {
    STATUS_TO_ICON_MAP["approved"] = "thumbs-up-line";
    STATUS_TO_ICON_MAP["declined"] = "thumbs-down-line";
    STATUS_TO_ICON_MAP["in_manual_review"] = "eye-line";
    STATUS_TO_ICON_MAP["live"] = "rocket-line";
    STATUS_TO_ICON_MAP["submitted"] = "notification-on-line";
    STATUS_TO_ICON_MAP["waiting_for_submission"] = "clock-line";
    STATUS_TO_ICON_MAP["waiting_manual_review"] = "clock-solid";
    return STATUS_TO_ICON_MAP;
}({});

//# sourceMappingURL=product-versions.js.map